exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-file\r\n{\r\n    position:absolute;\r\n    opacity:0;\r\n}\r\n\r\n.disableDiv {\r\n    pointer-events: none;\r\n    opacity: 0.6\r\n}\r\n\r\n.image-review{\r\n    margin-right:auto;\r\n    margin-left:auto;\r\n    display:block;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/products/e-fulfillment-form/e-fulfillment-form.component.css
// module id = 514
// module chunks = 0